import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Tocar una push lleva a su pantalla (ver `abrir` en public/sw.js).
 *
 * El service worker no navega él (en el iPhone `client.navigate()` falla sin avisar): le pasa la
 * dirección al CRM y el CRM navega con el router. Al arrancar, además, pregunta si quedó una
 * pendiente: iOS puede abrir la app después del toque, cuando el aviso ya pasó.
 */
export function useAbrirDesdeNotificacion() {
  const navigate = useNavigate();
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    const sw = navigator.serviceWorker;
    const onMensaje = (e: MessageEvent) => {
      const url = (e.data as { tipo?: string; url?: string } | null)?.tipo === 'abrir' ? (e.data as { url: string }).url : null;
      // Solo rutas internas del CRM: nunca un origen de afuera.
      if (!url || !url.startsWith('/') || url.startsWith('//')) return;
      sw.controller?.postMessage({ tipo: 'abierta' });
      navigate(url);
    };
    sw.addEventListener('message', onMensaje);
    sw.ready.then((reg) => (sw.controller ?? reg.active)?.postMessage({ tipo: 'pendiente?' })).catch(() => undefined);
    return () => sw.removeEventListener('message', onMensaje);
  }, [navigate]);
}
